import React, { FC } from "react";

interface Props {
    title:string,
    footer?:string
    children: string | JSX.Element | JSX.Element[]
}
const Card:FC<Props> = (props) =>{
    const {title,footer,children} = props;
    return(
        <div className="card">
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
          <div className="card-tools">
            <button type="button" className="btn btn-tool" data-card-widget="collapse" title="Collapse">
              <i className="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div className="card-body">
         {
            children
         }
        </div>
        {
         footer && 
        <div className="card-footer">
          {
           footer
          }
        </div>
        }
      </div>
    )
}
export default Card;